import { gql } from '@apollo/client';
import { useCallback } from 'react';
import { subscriptionsPublicClient } from 'lib/apollo/clients';

export const checkForInvite = gql`
  query ($email: String, $phone: String) {
    checkForInvite(email: $email, phone: $phone) {
      inviteExists
      businessName
      shortCode
    }
  }
`;

const useCheckForInvite = () =>
  useCallback(async (variables) => {
    try {
      const {
        data: {
          checkForInvite: { businessName, inviteExists, shortCode },
        },
      } = await subscriptionsPublicClient.query({
        query: checkForInvite,
        variables: variables,
      });

      return { businessName, inviteExists, shortCode };
    } catch (e) {
      throw e;
    }
  }, []);

export default useCheckForInvite;
